import React, { useState } from 'react'
import './ItemCount.css'


export const ItemCount = ({ stock, initial, onAdd }) => {
    const [count, setCount] = useState(initial)
    const increase = () => {
        if(count < stock) {
            setCount(count + 1)
        }
    }
    const decrease = () => {
        if(count > initial) {
            setCount(count - 1)
        }
    }
  return (
    <div className='flex flex-col justify-center items-center'>
        <div className='w-full text-center'>
            <button className="btn btnCtrl mt-5 w-2/12" onClick={decrease}>-</button>
            <span className="count m-5 text-2xl	">{count}</span>
            <button className="btn btnCtrl mt-5 w-2/12" onClick={increase}>+</button>
        </div>
        <div className='w-full text-center m-2'>
            <button className="btn agregar sm:w-4/5 md:" onClick={() => onAdd(count)}>Agregar al carrito</button>
        </div>
    </div>

  )
}
